const STORAGE_KEY = "weros_site_consent";
const ACCEPTED_EVENT = "weros:site-consent-accepted";
const REQUEST_EVENT = "weros:site-consent-request";

function safeStorageGet(key) {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeStorageSet(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch {
  }
}

function parseStoredConsent() {
  const raw = safeStorageGet(STORAGE_KEY);
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function currentConsentRoot() {
  return document.querySelector("[data-site-consent-banner]");
}

function currentConsentVersion() {
  const root = currentConsentRoot();
  return String(root?.dataset?.consentVersion || "");
}

function writeDocumentState(accepted) {
  document.documentElement.classList.toggle("site-consent-accepted", accepted);
  document.documentElement.classList.toggle("site-consent-pending", !accepted);
  document.body?.classList.toggle("site-consent-accepted", accepted);
  document.body?.classList.toggle("site-consent-pending", !accepted);
}

export function hasSiteConsent(version = currentConsentVersion()) {
  const stored = parseStoredConsent();
  if (!stored.version) return false;
  if (!version) return Boolean(stored.version);
  return stored.version === version;
}

export function acceptSiteConsent(version = currentConsentVersion()) {
  const grantedAt = new Date().toISOString();
  safeStorageSet(STORAGE_KEY, JSON.stringify({
    version,
    ts: grantedAt,
  }));
  writeDocumentState(true);
  window.dispatchEvent(new CustomEvent(ACCEPTED_EVENT, {
    detail: {
      version,
      ts: grantedAt,
    },
  }));
}

export function onSiteConsentAccepted(callback) {
  if (typeof callback !== "function") return () => {};
  const handler = (event) => callback(event.detail || {});
  window.addEventListener(ACCEPTED_EVENT, handler);
  return () => window.removeEventListener(ACCEPTED_EVENT, handler);
}

export function requestSiteConsentAttention() {
  window.dispatchEvent(new CustomEvent(REQUEST_EVENT));
}

export function initConsentBanner() {
  const root = currentConsentRoot();
  const version = currentConsentVersion();
  const button = root?.querySelector("[data-site-consent-accept]");
  const accepted = hasSiteConsent(version);
  writeDocumentState(accepted);
  if (!root) return;
  root.hidden = accepted;
  if (!accepted) root.removeAttribute("hidden");
  button?.addEventListener("click", () => {
    acceptSiteConsent(version);
    root.hidden = true;
  });
  window.addEventListener(REQUEST_EVENT, () => {
    if (hasSiteConsent(version)) return;
    root.hidden = false;
    root.classList.remove("is-attention");
    window.requestAnimationFrame(() => {
      root.classList.add("is-attention");
      button?.focus({ preventScroll: true });
      window.setTimeout(() => root.classList.remove("is-attention"), 900);
    });
  });
}
